
import { ChangeDetectionStrategy, Component, ElementRef, Inject, Input, ViewChild, DOCUMENT } from '@angular/core';

import { AimoProduct } from '../../../../model/product.model';

@Component({
    selector: 'aimo-product-code',
    templateUrl: './aimo-product-code.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoProductCodeComponent {
    @Input() product: AimoProduct;
    @Input() klass: string = '';
    @ViewChild('productId') productId: ElementRef<HTMLElement>;

    constructor(@Inject(DOCUMENT) private document: Document) {}

    selectProductId(code: string, $event: MouseEvent): void {
        $event.preventDefault();
        const selection = this.document.getSelection();
        const node = this.productId.nativeElement;
        const text = node.childNodes[0];
        const range = new Range();
        range.setStart(text, 0);
        range.setEnd(text, code.length);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}
